module.exports = __webpack_public_path__ + "img/caro1.07775f01.png";